<template>
  <!-- Location -->
  <section class="car-location common-padding">
    <div class="container">
      <div class="section-heading section-heading-nine aos" data-aos="fade-up">
        <div class="row align-items-center">
          <div class="col-md-3"></div>
          <div
            class="col-md-6 aos aos-init aos-animate text-center"
            data-aos="fade-up"
          >
            <h2>Popular Location of Properties</h2>
            <p>Sense Solutions For All Aspects near your Location.</p>
          </div>
          <div
            class="col-md-3 text-md-end aos aos-init aos-animate"
            data-aos="fade-up"
          >
            <router-link to="categories" class="btn btn-view"
              >View all Properties</router-link
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3">
          <router-link to="service-details"
            ><div
              class="car-location-img aos"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <img
                src="@/assets/img/city/car-location-1.png"
                class="img-fluid"
                alt=""
              />
              <span>Las Vegas</span>
            </div></router-link
          >
        </div>
        <div class="col-lg-5">
          <router-link to="service-details"
            ><div
              class="car-location-img aos"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <img
                src="@/assets/img/city/car-location-2.png"
                class="img-fluid"
                alt=""
              />
              <span>Singapore</span>
            </div></router-link
          >
        </div>
        <div class="col-lg-4">
          <router-link to="service-details"
            ><div
              class="car-location-img aos"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <img
                src="@/assets/img/city/car-location-3.png"
                class="img-fluid"
                alt=""
              />
              <span>Denmark</span>
            </div></router-link
          >
        </div>
        <div class="col-lg-4">
          <router-link to="service-details"
            ><div
              class="car-location-img aos"
              data-aos="fade-up"
              data-aos-delay="800"
            >
              <img
                src="@/assets/img/city/car-location-4.png"
                class="img-fluid"
                alt=""
              />
              <span>France</span>
            </div></router-link
          >
        </div>
        <div class="col-lg-5">
          <router-link to="service-details"
            ><div
              class="car-location-img aos"
              data-aos="fade-up"
              data-aos-delay="1000"
            >
              <img
                src="@/assets/img/city/car-location-5.png"
                class="img-fluid"
                alt=""
              />
              <span>Indonesia</span>
            </div></router-link
          >
        </div>
        <div class="col-lg-3">
          <router-link to="service-details"
            ><div
              class="car-location-img aos"
              data-aos="fade-up"
              data-aos-delay="1200"
            >
              <img
                src="@/assets/img/city/car-location-6.png"
                class="img-fluid"
                alt=""
              />
              <span>New York</span>
            </div></router-link
          >
        </div>
      </div>
    </div>
  </section>
  <!-- /Location -->
  <!-- Verified Owners -->
  <section class="verified-owner-section">
    <div class="container">
      <div class="section-heading section-heading-nine aos" data-aos="fade-up">
        <div class="row align-items-center">
          <div class="col-md-3"></div>
          <div
            class="col-md-6 aos aos-init aos-animate text-center"
            data-aos="fade-up"
          >
            <h2>Featured Verified Owners</h2>
            <p>Highlight the most popular owners</p>
          </div>
          <div
            class="col-md-3 text-md-end aos aos-init aos-animate"
            data-aos="fade-up"
          ></div>
        </div>
      </div>
      <div class="row align-items-center justify-content-center">
        <div
          class="col-md-4 col-lg-3 col-sm-6 aos"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div class="owner-card">
            <div class="owner-card-img">
              <router-link to="profile"
                ><img
                  src="@/assets/img/profiles/avatar-15.jpg"
                  class="img-fluid"
                  alt=""
              /></router-link>
            </div>
            <div class="owner-info">
              <div class="owner-name">
                <router-link to="profile">Jonny baristow</router-link>
                <span class="double-tick"
                  ><i class="fa-solid fa-check-double"></i
                ></span>
              </div>
              <span class="owner-list-span">50 Listings</span>
            </div>
          </div>
        </div>
        <div
          class="col-md-4 col-lg-3 col-sm-6 aos"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          <div class="owner-card">
            <div class="owner-card-img">
              <router-link to="profile"
                ><img
                  src="@/assets/img/profiles/avatar-16.jpg"
                  class="img-fluid"
                  alt=""
              /></router-link>
            </div>
            <div class="owner-info">
              <div class="owner-name">
                <router-link to="profile">Angeline Marshall</router-link>
                <span class="double-tick"
                  ><i class="fa-solid fa-check-double"></i
                ></span>
              </div>
              <span class="owner-list-span">25 Listings</span>
            </div>
          </div>
        </div>
        <div
          class="col-md-4 col-lg-3 col-sm-6 aos"
          data-aos="fade-up"
          data-aos-delay="600"
        >
          <div class="owner-card">
            <div class="owner-card-img">
              <router-link to="profile"
                ><img
                  src="@/assets/img/profiles/avatar-17.jpg"
                  class="img-fluid"
                  alt=""
              /></router-link>
            </div>
            <div class="owner-info">
              <div class="owner-name">
                <router-link to="profile">Abraham Musol</router-link>
                <span class="double-tick"
                  ><i class="fa-solid fa-check-double"></i
                ></span>
              </div>
              <span class="owner-list-span">30 Listings</span>
            </div>
          </div>
        </div>
        <div
          class="col-md-4 col-lg-3 col-sm-6 aos"
          data-aos="fade-up"
          data-aos-delay="800"
        >
          <div class="owner-card">
            <div class="owner-card-img">
              <router-link to="profile"
                ><img
                  src="@/assets/img/profiles/avatar-18.jpg"
                  class="img-fluid"
                  alt=""
              /></router-link>
            </div>
            <div class="owner-info">
              <div class="owner-name">
                <router-link to="profile">Rayon Akram</router-link>
                <span class="double-tick"
                  ><i class="fa-solid fa-check-double"></i
                ></span>
              </div>
              <span class="owner-list-span">35 Listings</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center">
          <router-link to="listingmap-list" class="verified-owner-list-btn"
            >View all Owners</router-link
          >
        </div>
      </div>
    </div>
  </section>
  <!-- /Verified Owners -->
</template>
